import { SyntheticEvent, useCallback } from 'react';

import { AutocompleteChangeDetails } from '@material-ui/lab';

import { FormFieldProps, useFormField } from '@spotify/confidence-core-react';
import {
  IdentityAutocompleteMuiProps as IdentityAutocompleteProps,
  OwnerAutocompleteMui as OwnerAutocomplete,
  useDefaultOwner,
} from '@spotify/plugin-confidence-iam-react';

/** @deprecated Legacy MUI copy — migrate consumers to the Encore OwnerFormField and delete. */
export type IdentityFormFieldMuiProps = FormFieldProps<string | null> &
  Omit<IdentityAutocompleteProps, 'value'>;

export const OwnerFormFieldMui = ({
  field = 'owner',
  initialValue,
  onChange,
  loading,
  ...props
}: IdentityFormFieldMuiProps) => {
  const [defaultOwner, , { loading: loadingUserIdentity }] = useDefaultOwner();
  const { value, setValue } = useFormField<string | null>(
    field,
    initialValue !== undefined ? initialValue : defaultOwner || undefined,
  );

  const handleChange = useCallback(
    (
      event: SyntheticEvent<EventTarget>,
      newIdentity: string | null,
      reason: string,
      details?: AutocompleteChangeDetails<string>,
    ) => {
      setValue(newIdentity);
      onChange?.(event, newIdentity, reason, details);
    },
    [onChange, setValue],
  );

  return (
    <OwnerAutocomplete
      value={value}
      onChange={handleChange}
      label="Owner"
      required
      data-testid="owner"
      loading={loadingUserIdentity || loading}
      {...props}
    />
  );
};
